import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinmumbai() {



const cardData = {
  keyword: " Mini Bus On Rent in Mumbai",

headingDescription: "Velocity Cab provides reliable and comfortable mini bus on rent in Mumbai, offering the perfect travel solution for group trips, corporate outings, weddings, school tours, family vacations, and sightseeing. Our well-maintained mini buses come with spacious seating, air-conditioning, and ample luggage space to ensure a comfortable journey for small to large groups. We offer flexible booking options including local travel, outstation trips, airport transfers, and full-day rentals with transparent pricing and no hidden charges. With professional drivers, punctual service, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for mini bus rental in Mumbai.",

topPlaces: [
 
  {
    title: "Daman",
    description: "Daman is a coastal town known for its tranquil beaches, Portuguese architecture, and historic forts. Travelers can explore Devka Beach, Jampore Beach, and colonial-era churches while enjoying a peaceful seaside getaway."
  },
  {
    title: "Silvassa",
    description: "Silvassa is the capital of Dadra and Nagar Haveli, offering lush gardens, wildlife attractions, museums, and tribal culture. It is an ideal destination for nature lovers and families seeking a refreshing vacation."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a revered pilgrimage destination famous for one of the twelve Jyotirlingas of Lord Shiva. Visitors can seek blessings at the ancient temple while enjoying the scenic surroundings of the Brahmagiri Hills."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a renowned pilgrimage site and wildlife sanctuary nestled in the Sahyadri Hills. It is known for its Jyotirlinga Temple, dense forests, and trekking opportunities, making it perfect for spiritual and nature enthusiasts."
  },
   {
    title: "Karjat",
    description: "Karjat is a scenic destination near Mumbai known for its lush greenery, rivers, trekking trails, and peaceful resorts. Travelers booking a sedan cab can enjoy a relaxing drive while exploring waterfalls, ancient caves, and beautiful countryside landscapes."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a popular adventure destination famous for paragliding, rolling hills, and picturesque lakes. Visitors can experience thrilling flights, nature walks, and breathtaking views of the Western Ghats."
  },
  {
    title: "Chiplun",
    description: "Chiplun is a picturesque town in the Konkan region surrounded by rivers, hills, and lush greenery. Travelers can visit the famous Parshuram Temple and enjoy the region's natural beauty and peaceful atmosphere."
  },
  {
    title: "Velas",
    description: "Velas is a charming coastal village famous for its Olive Ridley Turtle Festival and pristine beaches. Nature lovers can witness turtle conservation efforts and enjoy an eco-friendly getaway."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a breathtaking mountain pass known for waterfalls, misty valleys, and rich biodiversity. It is a favorite destination for monsoon road trips, birdwatching, and scenic photography."
  },
  {
    title: "Ratnagiri",
    description: "Ratnagiri is a beautiful coastal city known for its beaches, historic forts, Alphonso mango orchards, and cultural heritage. Visitors can explore Ratnadurg Fort, Ganeshgule Beach, and enjoy the region's scenic Konkan coastline."
  }
],



services: [
{
name: "Mini Bus Rental Mumbai",
description: "Mini bus rental Mumbai offers a convenient and comfortable travel solution for group journeys across the city and outstation routes. This service is ideal for family trips, school tours, corporate travel, and event transportation where multiple passengers need to travel together. Mini buses are designed with spacious seating, good legroom, and comfortable interiors to ensure a smooth journey. Professional drivers ensure safe navigation through city traffic and highways. Customers can choose from different seating capacities based on group size and travel requirements. Flexible booking options including hourly, daily, and outstation rentals make planning easy. With transparent pricing and reliable service, mini bus rental in Mumbai is the perfect choice for group travel."
},
{
name: "Mini Bus Hire Mumbai",
description: "Mini bus hire Mumbai provides reliable transportation for group travel with well-maintained vehicles and experienced drivers. This service is suitable for weddings, tours, corporate events, and school trips. Comfortable seating and smooth ride quality ensure a pleasant journey. Flexible rental plans allow customers to book as per their schedule. It is a cost-effective solution for large group transportation. This service ensures convenience and safety."
},
{
name: "AC Mini Bus on Rent Mumbai",
description: "AC mini bus on rent Mumbai ensures a comfortable journey with air-conditioned vehicles suitable for long-distance and city travel. This service is ideal for group tours, corporate travel, and events. Clean interiors and proper ventilation enhance passenger comfort. Professional drivers ensure safe and timely travel. Flexible booking options are available. It guarantees a pleasant travel experience."
},
{
name: "20 Seater Mini Bus Mumbai",
description: "20 seater mini bus Mumbai is perfect for medium-sized groups such as family outings, office trips, and school tours. The vehicle offers comfortable seating and sufficient space for luggage. It ensures a smooth journey for both city and outstation travel. Professional drivers provide safe and reliable service. This option is ideal for group travel with convenience. It is widely preferred for short trips."
},
{
name: "25 Seater Mini Bus Rental Mumbai",
description: "25 seater mini bus rental Mumbai is suitable for larger groups including corporate teams, wedding guests, and tour groups. The vehicle provides spacious seating, comfortable interiors, and smooth ride quality. It is ideal for long-distance travel and group outings. Professional drivers ensure safe and efficient travel. Flexible rental options make booking easy. It ensures a comfortable group travel experience."
},
{
name: "Mini Bus for Wedding Mumbai",
description: "Mini bus for wedding Mumbai offers convenient transportation for guests, family members, and event staff. This service ensures timely pickup and drop between venues. Spacious seating and comfortable interiors make travel easy for guests. Professional drivers ensure punctual and safe service. Flexible booking options are available for hourly and full-day use. It is perfect for smooth wedding transportation."
},
{
name: "Mini Bus for Corporate Events Mumbai",
description: "Mini bus for corporate events Mumbai provides reliable transport for office staff, conferences, team outings, and business events. This service ensures comfortable group travel with punctual pickups and drops. Well-maintained vehicles and professional drivers enhance the travel experience. Flexible scheduling allows easy coordination with event timings. It is ideal for corporate group travel. It ensures efficiency and comfort."
},
{
name: "Cheap Mini Bus on Rent Mumbai",
description: "Cheap mini bus on rent Mumbai offers budget-friendly group travel options without compromising on comfort and safety. This service is ideal for cost-conscious travelers who need reliable transportation. Economical rental plans are available for different needs. Well-maintained vehicles and professional drivers ensure smooth travel. Transparent pricing ensures no hidden charges. It is a perfect balance of affordability and comfort."
},
{
name: "Luxury Mini Bus Hire Mumbai",
description: "Luxury mini bus hire Mumbai provides premium travel experience with advanced features, comfortable seating, and stylish interiors. This service is ideal for VIP travel, corporate events, and special occasions. Spacious seating and smooth ride quality ensure maximum comfort. Professional chauffeurs ensure safe and punctual service. Flexible booking options are available. It guarantees a luxurious travel experience."
},
{
name: "Mini Bus for Outstation Mumbai",
description: "Mini bus for outstation Mumbai offers long-distance travel solutions for group tours to destinations like Pune, Lonavala, Mahabaleshwar, and Goa. This service ensures comfortable travel with spacious seating and reliable performance. Professional drivers ensure safe driving on highways and ghat roads. Flexible packages allow one way and round trip bookings. It is ideal for family tours and group trips. It ensures a hassle-free journey."
},
{
name: "Mini Bus with Driver Mumbai",
description: "Mini bus with driver Mumbai provides a complete travel solution with professional chauffeurs ensuring safe and comfortable journeys. Drivers are experienced and familiar with city and outstation routes. This service allows customers to relax and enjoy their trip without worrying about driving. Flexible rental options are available based on travel needs. Clean and well-maintained vehicles enhance the experience. It ensures a stress-free group travel experience."
},
{
name: "Mumbai Mini Bus Booking Online",
description: "Mumbai mini bus booking online allows customers to easily reserve mini buses with instant confirmation and flexible scheduling. Online platforms provide quick booking options with transparent pricing. Customers can choose vehicle types, seating capacity, and travel plans conveniently. Secure payment options ensure a safe transaction process. Dedicated support is available for assistance. It is the most convenient way to book group transportation."
}
],

tableData: [
["Mini Bus Rental Mumbai","Mini Bus Hire Mumbai"],
["AC Mini Bus on Rent Mumbai","20 Seater Mini Bus Mumbai"],
["25 Seater Mini Bus Rental Mumbai","Mini Bus for Wedding Mumbai"],
["Mini Bus for Corporate Events Mumbai","Cheap Mini Bus on Rent Mumbai"],
["Luxury Mini Bus Hire Mumbai","Mini Bus for Outstation Mumbai"],
["Mini Bus with Driver Mumbai","Mumbai Mini Bus Booking Online"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Group Travel Solution",
    WhyChoosedescription: "Velocity Cabs offers mini bus on rent in Mumbai with spacious seating, making it ideal for group travel, corporate outings, school trips, and family functions."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai city routes and highways, ensuring safe driving, smooth travel, and timely pickups for all passengers."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for mini bus rental in Mumbai. Customers receive complete fare details including per km charges, toll charges, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Mini Bus Availability",
    WhyChoosedescription: "Our mini bus rental service in Mumbai operates 24/7. Whether for airport transfers, events, or outstation travel, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Spacious & Fully AC Vehicles",
    WhyChoosedescription: "All mini buses are fully air-conditioned, well maintained, and designed with comfortable seating and ample legroom for a relaxed group travel experience."
  },
  {
    WhyChooseheading: "Multiple Seating Options",
    WhyChoosedescription: "Velocity Cabs offers mini buses in various seating capacities such as 12-seater, 17-seater, 20-seater, and 25-seater options to suit different group sizes."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Event Travel",
    WhyChoosedescription: "Mini buses are perfect for corporate events, employee transport, weddings, school trips, airport transfers, and outstation tours from Mumbai."
  },
  {
    WhyChooseheading: "Trusted Rental Service in Mumbai",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for mini bus rental in Mumbai due to professional drivers, well-maintained vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide mini bus on rent in Mumbai?", answer: "Yes, Velocity Cabs provides mini bus rental services in Mumbai for local and outstation group travel." },
  { question: "What is the price of mini bus on rent in Mumbai?", answer: "Mini bus rental typically starts from ₹25 to ₹35 per km depending on seating capacity and travel requirements." },
  { question: "What seating options are available?", answer: "We offer mini buses in 12, 17, 20, and 25-seater configurations suitable for different group sizes." },
  { question: "Is mini bus available for outstation trips?", answer: "Yes, mini buses are available for outstation travel from Mumbai to destinations like Pune, Lonavala, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Can I book mini bus for corporate events?", answer: "Yes, mini buses are ideal for corporate travel, employee transport, and business events." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our mini bus rental service in Mumbai operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all mini buses are fully air-conditioned and well maintained." },
  { question: "Can I book mini bus online?", answer: "Yes, customers can easily book mini bus on rent in Mumbai online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patil",
    feedback:
      "The mini bus on rent in Mumbai was perfect for our group trip. The seating was comfortable, the vehicle was clean, and the journey was well-managed from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback:
      "We hired a mini bus in Mumbai for a family outing, and the experience was excellent. The ride was smooth, the space was ample, and everything was organized very professionally.",
    rating: 5
  }
];


























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const miniBusMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mini Bus On Rent in Mumbai | Velocity Cabs",
  "description": "Rent a Mini Bus in Mumbai for weddings, corporate events, outstation trips, or group travel. 20-seater, 25-seater, AC, and luxury options with driver available at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mini Bus Rental Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Mini Bus Rental",
        "description": "Rent a Mini Bus for one-way travel in Mumbai with 20-seater, 25-seater, AC, and luxury options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mini Bus Rental",
        "description": "Comfortable round-trip rental of Mini Buses in Mumbai with private driver and multiple seating options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      <Helmet>
  <title>Mini Bus On Rent in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a Mini Bus in Mumbai for weddings, corporate events, outstation trips, or group travel. 20-seater, 25-seater, AC, and luxury options with driver available at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(miniBusMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinmumbai;